import I18n from '~/i18n';

const tr = (attr) => I18n.t(`event.date_filter.${attr}`);

export const dateFilters = [
  {label: tr('today'), uuid:'1d', q:1, u:'d'},
  {label: tr('seven_days'), uuid:'7d', q:7, u:'d'},
  {label: tr('fifteen_days'), uuid:'15d', q:15, u:'d'},
  {label: tr('last_month'), uuid:'1m', q:1, u:'M'},
  {label: tr('last_3_months'), uuid:'3m', q:3, u:'M'},
  {label: tr('last_year'), uuid:'1y', q:1, u:'Y'},
  {label: tr('all_time'), uuid:'0d', q:20, u:'Y'},
].map(dataLabel => ({
  uuid:   dataLabel.uuid || dataLabel.label,
  name: dataLabel.label,
  q: dataLabel.q,
  u: dataLabel.u,
}));

export const isTrajectory = (eventType) =>
  eventType === ('in_vehicle' || 'on_foot' || 'walking' || 'running');

export const trasnformGeolocationsToPolyline = (geolocations) =>{
  const geoArray = [];
  geolocations.map(item =>
    geoArray.push({read_at: item.read_at, lat: item.coords_latitude, lng: item.coords_longitude}));
    geoArray.shift();
  return geoArray;
};

export const whereToZoomMyMap = (distance) => {
  if(distance<1000)
    return 16;
  if(distance<10000)
    return 15;
  if(distance<30000)
    return 12;
  if(distance<100000)
    return 11;

  return 15;
};
